import StatusCodes from 'http-status-codes'
import { http, HttpResponse } from 'msw'

import { type Comment } from '@webapp/models/Comment'
import { type IApiV3Response } from '@webapp/services/api'
import { CommentMock } from '@webapp/tests/mocks/comment.factory'
import { type CreateCommentSchema } from '../CommentsAPI'

export const createCommentStub = (response?: Comment) => {
  return http.post<never, CreateCommentSchema, IApiV3Response<Comment>>(
    '/api/v3/comments/',
    () => {
      return HttpResponse.json(
        {
          data: response ?? CommentMock.build(),
        },
        { status: StatusCodes.CREATED }
      )
    }
  )
}
